<template>
    <CarouselSlide class="orders-statistics">
        <img src="/images/promo/interface-slider/orders-statistics-slide.png" alt="Orders statistics interface" />
    </CarouselSlide>
</template>

<script>
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  components: { CarouselSlide },
};
</script>

<style lang="scss" scoped>
.orders-statistics {
  border: 1px solid #CADDFC;
  border-radius: 16px;
  overflow: hidden;
}
</style>
